// 新房--详情--用户点评接口
import {get,post} from '../utils/request.js'

//静态数据获取
export const apiGetEstateComment = function (data) {
  return get('build/getEstateComment' , data);
}

//用户评论列表页
export const apiGetCommentList = function (data) {
  return get('build/getCommentList', data);
}



// WEBPACK FOOTER //
// ./src/api/evaluate.js